import React from 'react'
import './result-searcher.scss'
import CardArticle from '../../atoms/card-article/card-article';
import TitleTab from '../../../shared/components/atoms/title-tab/title-tab';

const ResultSearcher = ({result,valueSerched,numArticles,setnumArticles}) =>{
    return (
        <div className="f-ResultSearcher">
              {valueSerched && <TitleTab title={"Resultados para “"+ valueSerched +"”"} className="f-TitleTab f-TitleTab-pink"/>}
              <div className={valueSerched?"f-ResultSearcher-content": ""}>
              {(result && valueSerched) && result.length === 0 && <p className="f-element-not-found"> Se encontraron 0 resultados para "{valueSerched !== ""? valueSerched:"Tu búsqueda"}"</p>}
              {result && result.map((info, index) =>{
                  if (index < numArticles) {
                    return <CardArticle valueSerched={valueSerched} resultSize={result.length} key={index} index={index} item={info}/>
                  }
                  return null
                }
                
              )}
              
              </div>
              {result && result.length > numArticles && <p className="f-ResultSearcher-more" onClick={() => setnumArticles(numArticles + 6)}>Cargar más</p>}
        </div>
    )
}
export default ResultSearcher;
